import { ArrayHelpers, Copy, StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import React from 'react';
import CompetencyRecommendations from 'views/myDashboard/components/widgets/components/competencyRecommendations';

export const Recommends = ({ recommendationData, filterCompetencies }) => {
    if (!recommendationData) return null;

    const property = SystemText(
        `Dashboard/Widgets/PredictiveModel/Properties/${StringHelpers.capitalise(recommendationData.property || 'meetings')}`
    );

    const increase = Math.round(recommendationData.propertyIncrease);

    const recommendsText = SystemText('Dashboard/Widgets/PredictiveModel/Recommends', property, increase);

    if (!increase || increase <= 0) {
        const noChangeText = SystemText('Dashboard/Widgets/PredictiveModel/RecommendsNoChange');
        return <Copy value={noChangeText} />;
    }

    if (!ArrayHelpers.existsAndHasLength(recommendationData.competencies)) {
        const noCompsText = SystemText(
            'Dashboard/Widgets/PredictiveModel/RecommendsNoComps',
            property,
            Math.round(increase)
        );
        return <Copy value={noCompsText} />;
    }

    return (
        <CompetencyRecommendations
            text={recommendsText}
            comps={recommendationData?.competencies}
            filterCompetencies={filterCompetencies}
        />
    );
};

export default Recommends;
